import { createSlice } from "@reduxjs/toolkit";

export const diseaseSlice = createSlice({
    name: 'disease',
    initialState: {
        value: "1"
    },
    reducers: {
        setDisease: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setDisease } = diseaseSlice.actions;

export const getDisease = (state) => state.disease.value;

export default diseaseSlice.reducer;